const CONTENT_API = '/api/content';

async function request(path) {
  const response = await fetch(`${CONTENT_API}${path}`, {
    headers: { Accept: 'application/json' },
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.detail || `FrameParty API вернул ${response.status}`);
  }
  return payload;
}

export const framePartyContentApi = {
  titles: ({ query = '', type = '' } = {}) => {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    if (type) params.set('type', type);
    const suffix = params.toString();
    return request(`/titles${suffix ? `?${suffix}` : ''}`);
  },
  title: (slug) => request(`/titles/${encodeURIComponent(slug)}`),
  playlists: () => request('/playlists'),
};
